import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "pages/Home/Home";
import Privacy from "pages/Privacy/Privacy";
import Condition from "pages/Condition/Condition";
import Description from "pages/Description/Description";
import Pro from "pages/Pro/Pro";
import Dashboard from "pages/Dashboard/Dashboard";
import { NavApp } from "./NavApp";
import Authentication from "pages/Authentication/Authentication";
import React from "react";
import Profil from "pages/Profil/Profil";
import Race from "pages/Race/Race";

export const AppRoutes = () => {
  return (
    <BrowserRouter>
      <NavApp />
      <Routes>
        <Route path={"/"} element={<Home />} />
        <Route path={"*"} element={<Home />} />
        <Route path={"/dashboard"} element={<Dashboard />} />
        <Route path={"/privacy"} element={<Privacy />} />
        <Route path={"/condition"} element={<Condition />} />
        <Route path={"/description"} element={<Description />} />
        <Route path={"/pro"} element={<Pro />} />
        <Route path={"/auth"} element={<Authentication />} />
        <Route path={"/profil"} element={<Profil />} />
        <Route path={"/race"} element={<Race />} />
      </Routes>
    </BrowserRouter>
  );
};
